import React, { useEffect, useState } from "react";
import { adminSessions } from "../../adminApi";
import { Loader2, RefreshCw, Smartphone, Monitor, Tablet, MapPin } from "lucide-react";

function DeviceIcon({ device }) {
  if (device === "mobile") return <Smartphone className="w-3.5 h-3.5" />;
  if (device === "tablet") return <Tablet className="w-3.5 h-3.5" />;
  return <Monitor className="w-3.5 h-3.5" />;
}

function fmt(d) {
  if (!d) return "-";
  return new Date(d).toLocaleString("es-DO");
}

function relTime(d) {
  if (!d) return "-";
  const ms = Date.now() - new Date(d).getTime();
  const s = Math.floor(ms / 1000);
  if (s < 60) return `hace ${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `hace ${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `hace ${h}h`;
  return fmt(d);
}

export default function AdminMonitoring() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      setSessions(await adminSessions());
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 15 * 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="text-2xl font-extrabold text-gray-900 flex items-center gap-2">
            Monitoreo
            <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 text-xs font-bold">PRO</span>
          </h2>
          <p className="text-sm text-gray-500 mt-1">Conexiones en tiempo real (últimas 100). Auto-refresh cada 15s.</p>
        </div>
        <button onClick={load} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-blue-50 hover:bg-blue-100 text-[#1d6cb1] text-sm font-semibold">
          <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} /> Actualizar
        </button>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50 text-gray-600">
              <tr>
                <th className="px-4 py-3 text-left font-semibold">Usuario</th>
                <th className="px-4 py-3 text-left font-semibold">Hora</th>
                <th className="px-4 py-3 text-left font-semibold">IP</th>
                <th className="px-4 py-3 text-left font-semibold">Ubicación</th>
                <th className="px-4 py-3 text-left font-semibold">Dispositivo</th>
                <th className="px-4 py-3 text-left font-semibold">Tipo</th>
              </tr>
            </thead>
            <tbody>
              {loading && sessions.length === 0 && (
                <tr><td colSpan={6} className="text-center py-10 text-gray-500"><Loader2 className="w-5 h-5 animate-spin inline" /> Cargando...</td></tr>
              )}
              {!loading && sessions.length === 0 && (
                <tr><td colSpan={6} className="text-center py-10 text-gray-500">Aún no hay conexiones registradas.</td></tr>
              )}
              {sessions.map((s, i) => (
                <tr key={i} className="border-t border-gray-100 hover:bg-blue-50/30">
                  <td className="px-4 py-3">
                    <div className="font-semibold text-gray-900">{s.email}</div>
                  </td>
                  <td className="px-4 py-3 text-xs">
                    <div className="text-gray-900 font-semibold">{relTime(s.created_at)}</div>
                    <div className="text-gray-500">{fmt(s.created_at)}</div>
                  </td>
                  <td className="px-4 py-3 font-mono text-xs text-gray-700">{s.ip}</td>
                  <td className="px-4 py-3 text-xs text-gray-700">
                    <div className="inline-flex items-center gap-1">
                      <MapPin className="w-3 h-3" /> {[s.city, s.region, s.country].filter(Boolean).join(", ") || "Local"}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-700">
                    <span className="inline-flex items-center gap-1">
                      <DeviceIcon device={s.device} /> {s.device} · {s.os} · {s.browser}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold uppercase ${
                      s.kind === "register" ? "bg-emerald-100 text-emerald-800" : "bg-blue-100 text-blue-800"
                    }`}>{s.kind}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
